import { SolutionPageTemplate } from '@/components/SolutionPageTemplate';
import { UtensilsCrossed, Volume2, Leaf, Clock, IndianRupee, Shield } from 'lucide-react';

export default function RestaurantsPage() {
  return (
    <SolutionPageTemplate
      slug="restaurants"
      title="BESS for Restaurants"
      subtitle="Restaurants & Hospitality"
      description="Silent, zero-emission power for restaurants and hospitality venues. Compact footprint ideal for dense urban areas. No more diesel noise disrupting your guests."
      heroImage="/images/voltide-restaurant.png"
      path="/solutions/restaurants"
      sectorLabel="restaurants"
      useCaseParam="dg_replacement"
      benefits={[
        { icon: Volume2, title: 'Silent Operation', desc: 'No more diesel noise disturbing diners. Perfect for outdoor seating areas.' },
        { icon: Leaf, title: 'Green Dining', desc: 'Market your venue as eco-friendly. Attract sustainability-conscious customers.' },
        { icon: Clock, title: 'Instant Backup', desc: 'Millisecond switchover keeps kitchen equipment, POS, and lighting running.' },
        { icon: IndianRupee, title: 'Lower Costs', desc: 'Save 30-60% on backup power costs vs diesel generators.' },
        { icon: Shield, title: 'Compact Footprint', desc: 'A 250 kW BESS fits in a 10-ft container. Smaller than most DG sets.' },
        { icon: UtensilsCrossed, title: 'No Odour', desc: 'Zero exhaust means no diesel smell near your kitchen or dining area.' },
      ]}
      howItWorks={[
        { title: 'Menu of Options', desc: 'We assess your peak demand, backup hours needed, and available space to recommend the right BESS size.' },
        { title: 'Quick Installation', desc: 'Containerised system arrives ready. Typical installation in 2-3 days with minimal disruption.' },
        { title: 'Always-On Power', desc: 'Fully managed service with 24/7 monitoring. Focus on your food, not your power.' },
      ]}
      faqs={[
        { q: 'Can BESS handle a commercial kitchen load?', a: 'Yes. Our systems handle loads from 125 kW to 750+ kW, covering everything from small cafes to large-format restaurants with full commercial kitchens.' },
        { q: 'How much space does it need?', a: 'A 250 kW / 482 kWh system fits in a standard 10-ft container (3m x 2.5m). Often smaller than the DG set it replaces.' },
        { q: 'What if we need power during peak dining hours?', a: 'BESS provides instant, seamless power. No warm-up time needed—unlike diesel generators that take minutes to start.' },
      ]}
      productFilter={p => p.pcs_kw <= 500}
    />
  );
}
